import styled from 'styled-components';

const StyledContainer = styled.div`
  max-width: 720px;
  margin: auto;
`;

export default StyledContainer;
